import React from 'react'
import Dashboard from '../dashboard'
import IncidentsView from './page'

const Incidents = () => {
  return <Dashboard component={<IncidentsView />} />
}

export default Incidents
